<template>
  <div>
    <make-invoice-step-one-dialog
      :visible="this.step === 'step1'"
      :title="this.makeInvoiceStepOneDialog.title"
      :params="this.makeInvoiceStepOneDialog.params"
      :properties="this.properties"
      :view-source="viewSource"
      :location="location"
      @update:visible="visible => handleStepVisibleChange('step1', visible)"
      @lastFinsh="lastFinsh"
      @toStepHandler="toStepHandler"
      @generatedHandler="generatedHandler"
    />
    <!--  合并后两步弹窗页不再渲染（原 Step2 已并入 Step1）；组件文件保留，由 P1-T5/cleanup 决定是否删除  -->
    <make-invoice-step-two-dialog
      v-if="false"
      ref="makeInvoiceStepTwoDialog"
      :visible="false"
      :title="this.makeInvoiceStepTwoDialog.title"
      :params="this.makeInvoiceStepTwoDialog.params"
      :properties="this.properties"
      :location="location"
      @update:visible="visible => handleStepVisibleChange('step2', visible)"
      @lastFinsh="lastFinsh"
      @toStepHandler="toStepHandler"
      @generatedHandler="generatedHandler"
    />
    <!-- 开票弹窗 -->
    <invoice-detail-dialog
      ref="makeInvoiceDialog"
      :visible="this.step === 'step3'"
      :title="this.makeInvoiceDialog.title"
      :params="this.makeInvoiceDialog.params"
      :properties="this.properties"
      :view-source="viewSource"
      :location="location"
      @update:visible="visible => handleStepVisibleChange('step3', visible)"
      @lastFinsh="lastFinsh"
      @toStepHandler="toStepHandler"
      @pageChange="pageChange"
    />
  </div>
</template>

<script>

import makeInvoiceStepOneDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceStepOneDialog'
import makeInvoiceStepTwoDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceStepTwoDialog'
import invoiceDetailDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/invoiceDetailDialog'
import { getBillingTreeForInvoice, getBillingGroupTreeForInvoice } from '@/api/clearing/billingNative'
import { getBillPaymentTreeForInvoice } from '@/api/clearing/billPayment'
import URL from '@/api/urlTranslator'
import { getLoading } from '@/utils/utilBaseElement'
import { getInvoiceDetails, getNotInvoiceCharges } from '@/api/clearing/invoice'
import { queryInvoiceGoodsName } from '@/api/clearing/invoiceGoodsName'
import { cacheName, cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { existWorkflowGroup } from '@/api/workflow'
import { MAKE_INVOICE_INTERNAL_INVOICE } from '@/class/cargo/model/parameters/WorkflowConstants'
import { queryChargePushRecord } from '@/api/clearing/charge'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'

export default {
  name: 'StartMakeInvoice',
  components: { makeInvoiceStepOneDialog, makeInvoiceStepTwoDialog, invoiceDetailDialog },
  props: {
    viewSource: { type: String, required: false }, // 请求来源
    location: { type: String, required: false }
  },
  data() {
    return {
      step: '', // step1=makeInvoiceStepOneDialog ; step2=makeInvoiceStepTwoDialog ; step3=makeInvoiceDialog
      properties: {
        // mode: 0, // 弹窗模式[default:0] 0-开票模式  1-对冲开票模式
        isHedge: false, // 是否对冲
        isAr: true, // 是否应收

        makeInvoiceMethod: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单
        makeInvoiceMethodHedge: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单

        typeGroup: 'multi', // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票、title=按抬头开票
        invoiceType: 0, // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
        groupingMakeType: 0, // 发票种类：0=纸质发票、1=电子发票

        currencyGroup: 0, // 分币种开票：0=拆分币种开票、1=合并币种
        cbAssignCurrency: true, // 指定发票币种
        groupingCurrencyType: 0, // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
        currency: 'RMB', // 币种

        billingRateMap: {}, // 账单币种、账单汇率
        isGenCostInvoice: false, // 是否生成成本发票（生成成本发票开关已移除，固定为 false）
        costInvoiceProp: {},

        invoiceGoodsName: {}, // 发票项目名称
        settleDepartment: 0, // 结算部门
        settleDepartmentPrefix: '', // 结算部门归属工作号

        otherCurrencys: [], // 其它币种
        otherRates: [], // 其它币种汇率
        txtCurrency1: '',
        txtRate1: '',
        txtCurrency2: '',
        txtRate2: '',
        rateCache: {}, // 对比发票币种的汇率

        branchId: this.$store.getters.currentOfficeId, // 分公司 Session.getInstance().getOfficeId()
        inputByDep: this.$store.getters.currentDeptId, // 部门 Session.getInstance().currentDepartment.departmentId

        titleMap: {}, // 获取账单所对应的结算单位: getTitleMap()
        invoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(entities)
        hedgeInvoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(hedgeEntities)

        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        entities: [], // 开票实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        allCharges: [],
        chargeMap: {},
        invoices: [], // 生成发票列表
        invoice: {}, // 当前发票
        currentPage: 1, // 顺序号
        totalPage: 0, // 发票总数
        invoiceGoodsNameList: [], // 发票项目名称列表
        invoiceItemGoodsName: 0, // InvoiceItemGoodsName：开票发票项目默认货物或应税劳务名称
        defaultGoodsName: '', // InvoiceMergeName：合并开票费用名称
        receivedRadio: 'ALL', // 对冲开票，应收列表币种：全部/RMB/USD
        paymentRadio: 'ALL', // 对冲开票，应付列表币种：全部/RMB/USD
        showChargeDetailByInvoice: false, // ShowChargeDetailByInvoice：增值发票是否可以显示明细
        invoiceNoEditable: false, // InvoiceSearchEdit: 开票查询修改发票号
        costInfo: false, // costSplitInfo: 是否开启费用拆分金额校验
        useAutoCheckInvoicing: false, // 是否使用了自动勾选开票
        autoCheckInvoiceAmountEnable: false, // 是否使用自动勾选开票
        autoCheckInvoicingAmount: 0.00, // 自动勾选开票预设金额
        isInvoiceByEachBillingRate: false, // isInvoiceByEachBillingRate：是否按各自账单汇率来开票
        specificConstraintType: '', // 特定约束类型
        rbgShowChargeDetail: '', // 显示明细
        apInvoiceCreateMusthaveTitileAndNumber: false, // 应付发票创建必须填写发票号和开票抬头
        unInvoiceCreate: false
      },
      makeInvoiceStepOneDialog: {
        visible: false,
        title: this.$t('Invoice.invoice_invoicing'),
        params: {}
      },
      makeInvoiceStepTwoDialog: {
        visible: false,
        title: this.$t('Billing.Add'),
        params: {}
      },
      makeInvoiceDialog: { // 开票/收票弹窗页
        visible: false,
        title: this.$t('Invoice.invoice_invoicing'),
        params: {}
      },
      hmToFinanceApi: false,
      isEtowerOne: false // 账单来源是否为etowerOne
    }
  },
  computed: {
    url() {
      return URL
    }
  },
  watch: {
  },
  async created() {
    try {
      await existWorkflowGroup({
        officeId: this.$store.getters.currentOfficeId,
        formSubtype: MAKE_INVOICE_INTERNAL_INVOICE.code
      }).then(async res => {
        this.properties.invoiceTriggerBpm = res.data
      })
    } catch (e) {
      // error
    }
    await this.initConfig()
  },
  beforeMount() {
  },
  beforeDestroy() {
  },
  methods: {
    handleStepVisibleChange(step, visible) {
      if (!visible && this.step === step) {
        this.toStepHandler('')
      }
    },
    // 配置参数
    async initConfig() {
      await cache.load(cacheName.CONFIG)
      this.properties.invoiceItemGoodsName = Number(cache.config.get('InvoiceItemGoodsName'))
      this.properties.defaultGoodsName = String(cache.config.get('InvoiceMergeName'))
      this.properties.showChargeDetailByInvoice = String(cache.config.get('ShowChargeDetailByInvoice')) === '1'
      this.properties.invoiceNoEditable = String(cache.config.get('InvoiceSearchEdit')) === '1'
      this.properties.costInfo = Number(cache.config.get('costSplitInfo')) === 1
      this.properties.enableCustomizeRevokeInvoice = Number(cache.config.get('enableCustomizeRevokeInvoice')) === 1
      this.properties.interfaceName = String(cache.config.get('TaxControlInterfaceName'))
      this.properties.interfaceNameEI = String(cache.config.get('EITaxControlInterfaceName'))
      this.properties.terminalSn = String(cache.config.get('baiWangOriginTerminalSN'))
      this.properties.storageURL = String(cache.config.get('StorageURL'))
      this.properties.isInvoiceByEachBillingRate = Number(cache.config.get('isInvoiceByEachBillingRate')) === 1
      this.properties.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.properties.toExoSystemHC = String(cache.config.get('ToExoSystem')) === 'HC' // 海创
      this.properties.QdWarning = String(cache.config.get('QdWarning')) !== '0' // 全电接口-国税应急方案
      this.properties.FeiByAuth = Number(cache.config.get('FeiByAuth')) === 1 // 全电接口是否走实人认证
      this.properties.settlementCenterMode = String(cache.config.get('SettlementCenterMode')) === '1' // 锦昶共享中心
      this.properties.isEasyInoivceVietnam = this.properties.interfaceNameEI === InvoiceConstant.INVOICE_EASY_INOIVCE_VIETNAM // 杰贝越南税控
      this.properties.isBillPreInvoicing = String(cache.config.get('BillingNoteContainInvoiceReques')) // 太平账单预开发票
      this.hmToFinanceApi = cache.hqConfig.get('ToFinanceApi') === 'HM' // 上海虹迈
      this.properties.apInvoiceCreateMusthaveTitileAndNumber = String(cache.config.get('APInvoiceCreateMusthaveTitileAndNumber')) === '1' // 备注:应付发票创建必须填写发票号和开票抬头，如果未填写则发票不会保存。
    },
    async makeInvoice(parameter) {
      // CARGO-32907 开票页面点击金税导出有问题
      await this.initConfig()
      // 重置
      this.initMakeInvoice()
      // CARGO-17675 开票界面，开票模式选择账单，点击开票后，开票的类型和种类需要继承账单上的开票类型，开票种类
      if (parameter.selectedEntities && !parameter.isHedge) {
        let d = false
        let invoiceType = ''
        let invoiceMakeType = ''
        for (const data of parameter.selectedEntities) {
          if ((invoiceType && data.invoiceType && invoiceType !== data.invoiceType) ||
            invoiceMakeType && data.invoiceMakeType && invoiceMakeType !== data.invoiceMakeType) {
            d = true
            break
          }
          if (data.invoiceType) {
            invoiceType = data.invoiceType
          }
          if (data.invoiceMakeType) {
            invoiceMakeType = data.invoiceMakeType
          }
        }
        if (d) {
          this.$confirm(this.$t('CargoMsg.Cargo_invoiceNotInconsistent'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('Clearing.Confirm'),
            cancelButtonText: this.$t('Clearing.Cancel'),
            type: 'warning'
          }).then(() => {
            this.setTypeAndMakeType(invoiceType, invoiceMakeType)
            this.nextDo(parameter)
          })
        } else {
          this.setTypeAndMakeType(invoiceType, invoiceMakeType)
          await this.nextDo(parameter)
        }
      } else {
        await this.nextDo(parameter)
      }
    },
    // When charges already have invoiceUuid(s), callers can open the invoice detail dialog directly.
    async openInvoiceDetails(invoiceUuids) {
      await this.initConfig()
      this.initMakeInvoice()

      const keys = Array.from(new Set((invoiceUuids || []).filter(p => !StrUtils.isEmpty(p))))
      if (keys.length === 0) return

      this.loading = getLoading()
      try {
        const res = await getInvoiceDetails({ keys })
        this.properties.invoices = (res && res.data) ? res.data : []
        if (!this.properties.invoices || this.properties.invoices.length === 0) {
          this.$message.warning('未查询到发票详情')
          return
        }
        // Make sure the invoice detail dialog is in a consistent mode (paper vs e-invoice).
        // invoice.makeType: 0=paper, 1=e-invoice (used throughout invoiceDetailDialog.vue).
        const first = this.properties.invoices && this.properties.invoices.length > 0 ? this.properties.invoices[0] : null
        if (first && (first.makeType === 0 || first.makeType === 1)) {
          this.properties.groupingMakeType = first.makeType
        }
        if (first && !StrUtils.isEmpty(first.invoiceType)) {
          this.properties.invoiceType = first.invoiceType
        }
        this.properties.currentPage = 1
        this.step = 'step3'
        this.pageChange()
      } finally {
        this.loading.close()
      }
    },
    setTypeAndMakeType(invoiceType, invoiceMakeType) {
      const imt = InvoiceConstant.getCommonCN(invoiceMakeType, InvoiceConstant.INVOICE_CATEGORY)
      if (imt) {
        this.properties.groupingMakeType = imt.code
        if (!this.properties.useAutoCheckInvoicing) {
          this.properties.autoCheckInvoicingAmount = this.properties.groupingMakeType === 1 ? Number(cache.config.get('E-InvoiceMaxAmount')) : Number(cache.config.get('InvoiceMaxAmount'))
        }
      }
      const ifFei = this.properties.groupingMakeType === 1 && (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO || this.properties.toExoSystemYGSH)
      const it = InvoiceConstant.getCommonCN(invoiceType, ifFei ? InvoiceConstant.INVOICE_TYPES_FEI : InvoiceConstant.INVOICE_TYPES)
      if (it) {
        this.properties.invoiceType = it.code
      }
      if (this.properties.invoiceType === InvoiceConstant.INVOICE_TYPE_VAT_FEI.code || this.properties.invoiceType === InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code) {
        this.properties.specificConstraintType = '00'
      }
    },
    async nextDo(parameter) {
      if (parameter) {
        const properties = this.properties
        if (parameter.hasOwnProperty('makeInvoiceMethod')) {
          properties.makeInvoiceMethod = parameter['makeInvoiceMethod']
        }
        if (parameter.hasOwnProperty('makeInvoiceMethodHedge')) {
          properties.makeInvoiceMethodHedge = parameter['makeInvoiceMethodHedge']
        }
        if (parameter.hasOwnProperty('isAr')) {
          properties.isAr = parameter['isAr']
        }
        if (parameter.hasOwnProperty('isHedge')) {
          properties.isHedge = parameter['isHedge']
        }
        if (parameter.hasOwnProperty('isSkipInvoiceFrom')) {
          properties.isSkipInvoiceFrom = parameter['isSkipInvoiceFrom']
        }
        if (parameter.hasOwnProperty('step')) {
          this.step = parameter['step']
        }
        if (parameter.hasOwnProperty('useAutoCheckInvoicing')) {
          properties.useAutoCheckInvoicing = parameter['useAutoCheckInvoicing']
        }
        if (parameter.hasOwnProperty('autoCheckInvoiceAmountEnable')) {
          properties.autoCheckInvoiceAmountEnable = parameter['autoCheckInvoiceAmountEnable']
        }
        if (parameter.hasOwnProperty('autoCheckInvoicingAmount')) {
          properties.autoCheckInvoicingAmount = parameter['autoCheckInvoicingAmount']
        }
        this.initEntities(parameter)
        if (properties.isSkipInvoiceFrom && !properties.isHedge && properties.makeInvoiceMethod !== 0) {
          this.directGenerateInvoice()
        } else {
          await this.initPageCutover()
        }
        // 设置缓存
        if (LocalStorageUtilsNew.hasConfiguration('invoceFormPage_' + this.properties.isAr)) {
          const item = LocalStorageUtilsNew.getConfiguration('invoceFormPage_' + this.properties.isAr)
          if (item && (parameter.makeInvoiceMethod === 3 || parameter.makeInvoiceMethod === 4)) { // 账单、对账单
            if (item.hasOwnProperty('autoCheckInvoicingAmount')) {
              this.properties.autoCheckInvoicingAmount = item.autoCheckInvoicingAmount
            }
            if (item.hasOwnProperty('useAutoCheckInvoicing')) {
              this.properties.useAutoCheckInvoicing = item.useAutoCheckInvoicing
            }
          }
        }
      }
    },
    async initEntities(parameter) {
      if (this.properties.makeInvoiceMethod === 0) return
      let keys = []
      if (parameter.hasOwnProperty('keys')) {
        const normalKeys = parameter['keys'] // 正常开票的UUID
        if (normalKeys && normalKeys.length > 0) {
          keys = keys.concat(normalKeys)
        }
      }
      // if (parameter.hasOwnProperty('hedgeKeys')) {
      //   const hedgeKeys = parameter['hedgeKeys'] // 对冲开票的UUID
      //   if (hedgeKeys && hedgeKeys.length > 0) {
      //     keys = keys.concat(hedgeKeys)
      //   }
      // }
      if (keys.length === 0) return
      // 单选标记：用户勾选的记录数为 1 时，发票类型可按税率与结算单位「税率-发票类型配置」精确匹配
      this.properties.isSingleSelect = keys.length === 1
      this.properties.entities = []
      // 开票方式[default:1] 1-费用 2-业务 3-账单 4-对账单 5-付款申请模块收票弹窗
      const makeInvoiceMethod = this.properties.makeInvoiceMethod
      if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2) {
        this.loading = getLoading()
        await getNotInvoiceCharges({ 'keys': keys }).then(res => {
          console.log('getNotInvoiceCharges', res)
          this.properties.entities = res.data
        }).finally(() => {
          this.loading.close()
        })
      } else if (makeInvoiceMethod === 3) {
        this.loading = getLoading()
        await getBillingTreeForInvoice({ billingKeys: keys }).then(res => {
          if (res.data && res.data.length > 0) {
            this.properties.entities = res.data
            this.properties.isEtowerOne = res.data.some(billing => billing.source && billing.source === ChargeConstants.ETOWER_ONE.chineseName)
          }
        }).finally(() => {
          this.loading.close()
        })
      } else if (makeInvoiceMethod === 4) {
        this.loading = getLoading()
        await getBillingGroupTreeForInvoice(keys).then(res => {
          if (res.data && res.data.length > 0) {
            console.log('getNotInvoiceCharges', res)
            this.properties.entities = res.data
          }
        }).finally(() => {
          this.loading.close()
        })
      } else if (makeInvoiceMethod === 5) {
        this.loading = getLoading()
        await getBillPaymentTreeForInvoice({ billPaymentKeys: keys }).then(res => {
          if (res.data && res.data.length > 0) {
            this.properties.entities = res.data
          }
        }).finally(() => {
          this.loading.close()
        })
        // this.doMakeInvoice()
      }
      // 对冲开票
      if (this.properties.isHedge) {
        await this.initEntitiesHedge(parameter)
      }
      console.log('entities', this.properties.entities)
      console.log('hedgeEntities', this.properties.hedgeEntities)
      console.log('isAr', this.properties.isAr)
      this.checkBillingRate()
      this.toQueryInvoiceGoodsName()
      if (this.hmToFinanceApi) {
        const chargeMap = new Map()
        for (const item of this.properties.allEntities) {
          if (this.properties.makeInvoiceMethod === 1 || this.properties.makeInvoiceMethod === 2) { // 按费用/业务
            chargeMap.set(item.uuid, item)
          } else if (item.entity === 'charge') {
            chargeMap.set(item.uuid, item)
          }
        }
        if (chargeMap.size > 0) {
          const fkUuids = Array.from(chargeMap.keys, p => `'${p}'`).join(',')
          queryChargePushRecord({ interfaceCategory: 4, fkUuids }).then(res => {
            for (const record of res.data) {
              const charge = chargeMap.get(record.fkUuid)
              if (charge) {
                charge.chargeSyncExternalStatus = record.sendStatus
                charge.chargeSyncExternalFailReason = record.sendResult
              }
            }
          })
        }
      }
    },
    async initEntitiesHedge(parameter) {
      console.log('initEntitiesHedge', parameter)
      if (this.properties.makeInvoiceMethodHedge === 0) return
      let keys = []
      if (parameter.hasOwnProperty('hedgeKeys')) {
        const hedgeKeys = parameter['hedgeKeys'] // 对冲开票的UUID
        if (hedgeKeys && hedgeKeys.length > 0) {
          keys = keys.concat(hedgeKeys)
        }
      }
      if (keys.length === 0) return
      this.properties.hedgeEntities = []
      // 开票方式[default:1] 1-费用 2-业务 3-账单 4-对账单 5-付款申请模块收票弹窗
      const makeInvoiceMethod = this.properties.makeInvoiceMethodHedge
      if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2) {
        this.loading = getLoading()
        await getNotInvoiceCharges({ 'keys': keys }).then(res => {
          console.log('getNotInvoiceCharges', res)
          this.properties.hedgeEntities = res.data
        }).finally(() => {
          this.loading.close()
        })
      } else if (makeInvoiceMethod === 3) {
        this.loading = getLoading()
        await getBillingTreeForInvoice({ billingKeys: keys }).then(res => {
          if (res.data && res.data.length > 0) {
            this.properties.hedgeEntities = res.data
          }
        }).finally(() => {
          this.loading.close()
        })
      } else if (makeInvoiceMethod === 4) {
        this.loading = getLoading()
        await getBillingGroupTreeForInvoice(keys).then(res => {
          if (res.data && res.data.length > 0) {
            console.log('getNotInvoiceCharges', res)
            this.properties.hedgeEntities = res.data
          }
        }).finally(() => {
          this.loading.close()
        })
      } else if (makeInvoiceMethod === 5) {
        this.loading = getLoading()
        await getBillPaymentTreeForInvoice({ billPaymentKeys: keys }).then(res => {
          if (res.data && res.data.length > 0) {
            this.properties.hedgeEntities = res.data
          }
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 重置开票相关
    initMakeInvoice() {
      this.properties.branchId = this.$store.getters.currentOfficeId
      this.properties.inputByDep = this.$store.getters.currentDeptId // CARGO-17952，H5对账页签开票弹出没有获取到部门
      this.properties.isHedge = false
      this.properties.typeGroup = 'multi' // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票、title=按抬头开票
      this.properties.invoiceType = 7 // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
      this.properties.groupingMakeType = 1 // 发票种类：0=纸质发票、1=电子发票
      this.properties.currencyGroup = 0 // 分币种开票：0=拆分币种开票、1=合并币种
      this.properties.cbAssignCurrency = true // 指定发票币种
      this.properties.groupingCurrencyType = 0 // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
      this.properties.currency = 'RMB' // 币种（固定默认RMB）
      this.properties.allowModifyCurrency = false // 是否允许修改币种（静默透传）
      this.properties.billingRateMap = {} // 账单币种、账单汇率
      this.properties.isGenCostInvoice = false // 生成成本发票开关已移除，固定为 false
      this.properties.costInvoiceProp = {}
      this.properties.invoiceGoodsName = {} // 发票项目名称
      this.properties.settleDepartment = Number(this.$store.getters.currentDeptId) || 0 // 结算部门，默认使用当前登录用户部门
      this.properties.settleDepartmentPrefix = '' // 结算部门归属工作号
      this.properties.otherCurrencys = [] // 其它币种
      this.properties.otherRates = [] // 其它币种汇率
      this.properties.txtCurrency1 = ''
      this.properties.txtRate1 = ''
      this.properties.txtCurrency2 = ''
      this.properties.txtRate2 = ''
      this.properties.rateCache = {} // 对比发票币种的汇率
      // step3 invoice detail state must be reset; otherwise stale invoice can be shown
      // when getInvoiceDetails returns empty.
      this.properties.invoices = []
      this.properties.invoice = {}
      this.properties.currentPage = 1
      this.properties.totalPage = 0
      // 默认开票信息
      if (LocalStorageUtilsNew.hasConfiguration('invoceFormPage_' + this.properties.isAr)) {
        const item = LocalStorageUtilsNew.getConfiguration('invoceFormPage_' + this.properties.isAr)
        console.log('invoceFormPage_' + this.properties.isAr, item)
        this.properties.typeGroup = item.typeGroup
        this.properties.invoiceType = item.invoiceType
        this.properties.currency = item.currency
        this.properties.allowModifyCurrency = item.hasOwnProperty('allowModifyCurrency') ? item.allowModifyCurrency : true
        this.properties.groupingCurrencyType = item.groupingCurrencyType
        this.properties.groupingMakeType = item.groupingMakeType
        if (this.properties.groupingCurrencyType === 0) {
          this.properties.currencyGroup = 1
          this.properties.cbAssignCurrency = true
        } else if (this.properties.groupingCurrencyType === 1) {
          this.properties.currencyGroup = 0
          this.properties.cbAssignCurrency = true
        } else if (this.properties.groupingCurrencyType === 2) {
          this.properties.currencyGroup = 0
          this.properties.cbAssignCurrency = false
        }
      }
      if (this.properties.allowModifyCurrency === false) {
        this.properties.currency = 'RMB'
      }
      this.properties.autoCheckInvoiceAmountEnable = false
      if (this.properties.useAutoCheckInvoicing) {
        this.properties.autoCheckInvoiceAmountEnable = true
      } else {
        this.properties.autoCheckInvoicingAmount = this.properties.groupingMakeType === 1 ? Number(cache.config.get('E-InvoiceMaxAmount')) : Number(cache.config.get('InvoiceMaxAmount'))
      }
    },
    // 发票项目名称列表
    toQueryInvoiceGoodsName() {
      this.properties.invoiceGoodsNameList = []
      const requestBody = { 'officeId': this.$store.getters.currentOfficeId }
      console.log('officeId', requestBody)
      this.loading = getLoading()
      queryInvoiceGoodsName(requestBody).then(res => {
        console.log('queryInvoiceGoodsName', res)
        this.properties.invoiceGoodsNameList = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    checkBillingRate() {
      const entities = this.properties.entities
      let billingRateMap = {}
      const billingRateMap2 = {}
      const allEntities = []
      allEntities.push(...entities)
      // 对冲
      if (this.properties.isHedge && this.properties.hedgeEntities && this.properties.hedgeEntities.length > 0) {
        allEntities.push(...this.properties.hedgeEntities)
      }
      this.properties.allEntities = allEntities
      for (let i = 0; i < allEntities.length; i++) {
        const item = allEntities[i]
        let billingCurrency = ''
        let sourceCurrency1 = ''
        let sourceCurrency2 = ''
        let sourceCurrency3 = ''
        let sourceRate1 = 0
        let sourceRate2 = 0
        let sourceRate3 = 0
        if (item['entity'] === 'charge' || item.entity === undefined) {
          // 没开账单
          if (!item['billingUuid']) {
            billingRateMap = {}
            return
          }
          if (item['entity'] === 'charge') { // 按账单开票
            billingCurrency = item['billingCurrency']
            sourceCurrency1 = item['billingSourceCurrency1']
            sourceCurrency2 = item['billingSourceCurrency2']
            sourceCurrency3 = item['billingSourceCurrency3']
            sourceRate1 = item['billingSourceRate1']
            sourceRate2 = item['billingSourceRate2']
            sourceRate3 = item['billingSourceRate3']
          } else if (item.entity === undefined) { // 按费用/业务
            billingCurrency = item['billingCurrency']
            sourceCurrency1 = item['sourceCurrency1']
            sourceCurrency2 = item['sourceCurrency2']
            sourceCurrency3 = item['sourceCurrency3']
            sourceRate1 = item['sourceRate1']
            sourceRate2 = item['sourceRate2']
            sourceRate3 = item['sourceRate3']
          } else {
            continue
          }
          // 账单币种
          if (billingRateMap['currency']) {
            if (billingRateMap['currency'] !== billingCurrency) {
              billingRateMap = {}
              return
            }
          } else {
            billingRateMap['currency'] = billingCurrency
          }
          // CARGO-8458，多个账单不同汇率开票，发票金额不等于账单金额相加
          if (this.properties.isInvoiceByEachBillingRate) {
            const billingUuid = item['billingUuid']
            // sourceCurrency1
            if (sourceCurrency1) {
              if (!billingRateMap2.hasOwnProperty(sourceCurrency1 + billingUuid)) {
                billingRateMap2[sourceCurrency1 + billingUuid] = sourceRate1
              }
            }
            // sourceCurrency2
            if (sourceCurrency2) {
              if (!billingRateMap2.hasOwnProperty(sourceCurrency2 + billingUuid)) {
                billingRateMap2[sourceCurrency2 + billingUuid] = sourceRate2
              }
            }
            // sourceCurrency3
            if (sourceCurrency3) {
              if (!billingRateMap2.hasOwnProperty(sourceCurrency3 + billingUuid)) {
                billingRateMap2[sourceCurrency3 + billingUuid] = sourceRate3
              }
            }
          }
          // sourceCurrency1
          if (sourceCurrency1) {
            if (billingRateMap.hasOwnProperty(sourceCurrency1)) {
              if (!this.properties.isInvoiceByEachBillingRate && billingRateMap[sourceCurrency1] !== sourceRate1) {
                billingRateMap = {}
                return
              }
            } else {
              billingRateMap[sourceCurrency1] = sourceRate1
            }
          }
          // sourceCurrency2
          if (sourceCurrency2) {
            if (billingRateMap.hasOwnProperty(sourceCurrency2)) {
              if (!this.properties.isInvoiceByEachBillingRate && billingRateMap[sourceCurrency2] !== sourceRate2) {
                billingRateMap = {}
                return
              }
            } else {
              billingRateMap[sourceCurrency2] = sourceRate2
            }
          }
          // sourceCurrency3
          if (sourceCurrency3) {
            if (billingRateMap.hasOwnProperty(sourceCurrency3)) {
              if (!this.properties.isInvoiceByEachBillingRate && billingRateMap[sourceCurrency3] !== sourceRate3) {
                billingRateMap = {}
                return
              }
            } else {
              billingRateMap[sourceCurrency3] = sourceRate3
            }
          }
        }
      }
      this.properties.billingRateMap = billingRateMap
      this.properties.billingRateMap2 = billingRateMap2
    },
    directGenerateInvoice() {
    },
    initPageCutover() {
      const step = this.properties.makeInvoiceMethod === 0 ? 'step3' : 'step1'
      if (step === 'step3') {
        this.properties.invoices = this.properties.entities
        this.properties.currentPage = 1
        this.pageChange()
      }
    },
    lastFinsh() {
      this.makeInvoiceDialog.visible = false
    },
    toStepHandler(data) { // 下一步、上一步
      if (!data) {
        this.properties.autoCheckInvoicingAmount = 0.0
        this.properties.useAutoCheckInvoicing = false
        this.properties.autoCheckInvoiceAmountEnable = false
        this.$emit('toStepHandler', '')
      }
      this.step = data
    },
    generatedHandler(data) {
      console.log('generatedHandler:', data)
      this.properties.currentPage = 1
      this.pageChange()
      this.step = data
      if (data === 'step3' && (this.viewSource === 'bill' || this.viewSource === 'reconciliation' || this.viewSource === 'billGroup' || this.viewSource === 'invoice' || this.viewSource === 'overseaBilling' || this.viewSource === 'internalBillInfo')) {
        this.$emit('reloadData')
      }
    },
    pageChange(data) { // 切换发票
      this.properties.totalPage = this.properties.invoices.length
      if (this.properties.currentPage > this.properties.totalPage) {
        this.properties.currentPage = this.properties.totalPage
      }
      if (this.properties.currentPage < 1) {
        this.properties.currentPage = 1
      }
      if (this.properties.totalPage > 0) {
        this.properties.invoice = this.properties.invoices[this.properties.currentPage - 1]
        // 增票合并/显示明细
        if (this.properties.invoice.ar && [2, 3].includes(this.properties.invoice.invoiceType)) {
          this.properties.rbgShowChargeDetail = 'merge'
          for (const invoiceItem of this.properties.invoice.invoiceItemList) {
            if (invoiceItem.goodsName.indexOf('\n') > -1) {
              this.properties.rbgShowChargeDetail = 'detail'
            }
          }
        } else if (this.properties.invoice.ar && [0, 1, 4].includes(this.properties.invoice.invoiceType)) {
          this.properties.rbgShowChargeDetail = 'merge'
          if (!StrUtils.isEmpty(this.properties.invoice.partAmount) && this.properties.invoice.partAmount.indexOf('\n') > -1) {
            this.properties.rbgShowChargeDetail = 'detail'
          }
        } else if (this.properties.invoice.ar && [6, 7].includes(this.properties.invoice.invoiceType)) {
          this.properties.rbgShowChargeDetail = 'merge'
          for (const invoiceItem of this.properties.invoice.invoiceItemList) {
            if (invoiceItem.goodsName.indexOf('\n') > -1) {
              this.properties.rbgShowChargeDetail = 'detail'
            }
          }
        } else {
          this.properties.rbgShowChargeDetail = 'merge'
        }
        //
        this.$refs.makeInvoiceDialog.initBaseData()
      }
    }
  }
}
</script>

<style scoped>
</style>
